/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_Filter_AllInputs */

const en_directory_external_directories_filter_all = /** @type {(inputs: Directory_External_Directories_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All types`)
};

const zh_directory_external_directories_filter_all = /** @type {(inputs: Directory_External_Directories_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部类型`)
};

/**
* | output |
* | --- |
* | "All types" |
*
* @param {Directory_External_Directories_Filter_AllInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_filter_all = /** @type {((inputs?: Directory_External_Directories_Filter_AllInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_Filter_AllInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_filter_all(inputs)
	return zh_directory_external_directories_filter_all(inputs)
});
export { directory_external_directories_filter_all as "directory.external_directories.filter_all" }